import injectSheet from 'react-jss'
import AddButton from './AddButton'
import styles from './AddButton.styles'

export default injectSheet(styles)(AddButton)
